import React from 'react';
import { Col, Row } from 'antd';
import EditSceneText from './edit-scene-text/edit-scene-text';

const SceneVoiceoverEdit = () => {
  return (
    <Row className={'edit-scene'} gutter={[10, 15]}>
      <Col span={24}>
        <EditSceneText />
      </Col>
    </Row>
  );
};

export default SceneVoiceoverEdit;
